exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CzgYfRRMlERKpe{cursor:pointer;margin:0 -12px;padding:4px 12px}.CzgYfRRMlERKpe:hover{background-color:#f4f5f7}._2JxGvjj_Uq0A0H{color:#a5adba}._2JxGvjj_Uq0A0H:hover{background-color:inherit}.CzgYfRRMlERKpe._2JxGvjj_Uq0A0H{cursor:not-allowed}._2JxGvjj_Uq0A0H ._3eguofGPxklNDb{color:#a5adba}._3JWcb2DQedjEve{font-size:12px;margin:0}._39vHcAGvNhCSRc{color:#eb5a46}", ""]);

// exports
exports.locals = {
	"boardVisibilityOption": "CzgYfRRMlERKpe",
	"boardVisibilityOptionDisabled": "_2JxGvjj_Uq0A0H",
	"boardVisibilityIcon": "_3eguofGPxklNDb",
	"boardVisibilityOptionDescription": "_3JWcb2DQedjEve",
	"boardVisibilityDisabledMessaging": "_39vHcAGvNhCSRc"
};